import styled from 'styled-components';

export const FloatingButton = styled.button`
    position: fixed;
    bottom: 24px;
    left: 50%;
    transform: translateX(-50%);
    background: #579DFF;
    color: #1D2125;
    border: none;
    border-radius: 20px;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    z-index: 100;
    transition: background 0.2s ease, transform 0.2s ease;

    &:hover {
        background: #85B8FF;
        transform: translateX(-50%) translateY(-2px);
    }

    svg {
        width: 16px;
        height: 16px;
        color: #1D2125 !important;
    }
`;
